module.exports = __webpack_public_path__ + "static/bg-banner-cc-8012b06863438887d951ba6ead92d98f.png";